import { AbgwUpstream } from '@schema';

const mapper = (upstream: AbgwUpstream) => ({
  ...upstream,
  name: upstream.address,
  balancing_threshold_percent: upstream.settings?.balancing_threshold_percent ?? null,
});

export type AbgwUpstreamMapped = ReturnType<typeof mapper>;

export default mapper;
